import React from 'react';

import Spinner from './Spinner';

const GraphLoader = () => {
  const loaderContainerStyle = {
    height: 320,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  };

  return (
    <div style={loaderContainerStyle}>
      <Spinner color="primary" />
    </div>
  );
};

export default GraphLoader;
